import { Controller } from "react-hook-form";
import { usePromotePanel, PROMOTE_STEPS } from "../context/PromotePanelContext";
import { PromoteStepHelpTrigger } from "./PromoteStepHelpTrigger";
import { MarketingTemporalSelector } from "@/react/components/marketing/temporal";
import { MarketingContentDescription } from "./MarketingContentDescription";
import { PromoteVisibilityFields } from "./PromoteVisibilityFields";

const MAX_CAPTION_LENGTH = 500;

export const ClassifyStep = () => {
  const { form, temporalTags } = usePromotePanel();
  const watchCaption = form.watch("caption");
  const watchAltText = form.watch("altText");
  const { errors } = form.formState;

  return (
    <div className="space-y-5 px-0.5">
      <Controller
        name="temporalTagId"
        control={form.control}
        render={({ field }) => (
          <MarketingTemporalSelector
            headerEnd={
              <PromoteStepHelpTrigger
                stepLabel={PROMOTE_STEPS[0].label}
                helpText={PROMOTE_STEPS[0].helpText}
              />
            }
            temporalTags={temporalTags}
            selectedTagId={field.value ?? null}
            onSelect={field.onChange}
          />
        )}
      />

      {form.formState.errors.temporalTagId ? (
        <p className="text-sm text-destructive">{form.formState.errors.temporalTagId.message}</p>
      ) : null}

      <MarketingContentDescription
        caption={watchCaption ?? ""}
        altText={watchAltText ?? ""}
        onCaptionChange={(val) => form.setValue("caption", val)}
        onAltTextChange={(val) => form.setValue("altText", val)}
        captionMaxLength={MAX_CAPTION_LENGTH}
        captionError={errors.caption?.message}
        altTextError={errors.altText?.message}
      />

      <PromoteVisibilityFields />
    </div>
  );
};
